import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Logger, LoggingService } from 'ionic-logging-service';
import { Observable, Subscriber } from 'rxjs';
import { IScanResource } from './model/IScanResource.model';
import { delay, finalize, retryWhen, take, tap } from 'rxjs/operators';
import { IPagingInfo } from './model/IPagingInfo.model';

@Injectable({
  providedIn: 'root'
})
export class CaptureHistoryService {

  private httpErrorResponse: HttpErrorResponse;
  private logger: Logger;

  constructor(
    private httpClient: HttpClient,
    private loggingService: LoggingService,
  ) {
    this.logger = this.loggingService.getLogger("[CaptureHistoryService]");
    const methodName = "ctor";
    this.logger.entry(methodName);
  }

  public getScanUrl(currentUserUrl: string): Observable<string> {
    this.logger.info('getScanUrl()');
    return new Observable<string>((observer: Subscriber<string>) => {
      this.httpClient.get<string>(currentUserUrl)
        .pipe(retryWhen(error => error.pipe(
          delay(1000),
          take(3),
          // return httpErrorResponse.status > 499 ? Observable.of(true) : Observable.throw(httpErrorResponse);
          tap((httpErrorResponse: HttpErrorResponse) => { this.httpErrorResponse = httpErrorResponse }),
          finalize(() => {
            observer.error(this.httpErrorResponse);
            observer.complete();
          })
        )))
        .subscribe((tenantUser: any) => {
          // this.logger.info(JSON.stringify(tenantUser));
          const scanJobsUrl: string = tenantUser['_links']['px:scans']['href'];
          observer.next(scanJobsUrl);
          observer.complete();
        });
    });
  }

  public getScanResources(scansUrl: string, page: number, pageSize: number, sort?: string, direction?: string): Observable<object> {
    this.logger.info('getScans()');
    scansUrl += '?page=' + page + '&pageSize=' + pageSize;
    sort ? scansUrl += '&sort=' + sort : '';
    direction ? scansUrl += '&direction=' + direction : '';
    return new Observable<object>((observer: Subscriber<object>) => {
      this.httpClient.get<object>(scansUrl)
        .pipe(retryWhen(error => error.pipe(
          delay(1000),
          take(3),
          // return httpErrorResponse.status > 499 ? Observable.of(true) : Observable.throw(httpErrorResponse);
          tap((httpErrorResponse: HttpErrorResponse) => { this.httpErrorResponse = httpErrorResponse }),
          finalize(() => {
            observer.error(this.httpErrorResponse);
            observer.complete();
          })
        )))
        .subscribe((rawRelease: object) => {
          observer.next(this.deserializeScanResources(rawRelease));
          observer.complete();
        });
    });
  }

  public deserializeScanResources(data): Array<IScanResource> {
    const scans = new Array<IScanResource>();
    scans["pagingObject"] = data["page"] as IPagingInfo;
    if (data["_embedded"]) {
      const scanDataArray: Array<any> = data["_embedded"]["px:scans"] as Array<any>;

      scanDataArray.forEach(scanData => {
        scans.push(this.deserializeScanResource(scanData));
      });
    }
    return scans;
  }

  public deserializeScanResource(scanData: any) {
    //WorkflowID and Error are optional depending on Bret's decision on adding this

    const destination: string = scanData["destinations"] ? scanData["destinations"][0] : "";
    let type: string;
    const workflowActivities : any[] = scanData['_embedded']['workflowActivities'];
    if (scanData["bypassOutputCreation"]) {
      type = 'JPG'
    } else if (workflowActivities.some(a => a.type === "GENERATE_DOCX")) {
      type = 'MicrosoftWord'
    } else if (workflowActivities.some(a => a.type === "GENERATE_SEARCHABLE_PDF")) {
      type = 'PDF'
    } else {
      type = 'UnknownFileType';
    }

    const scanResource: IScanResource = {
      state: scanData["state"],
      created: scanData["created"],
      fileType: type,
      destinationType: destination,
      workflowName: scanData["cachedWorkflowName"]
    };
    return scanResource;
  }
}
